export default __webpack_public_path__ + "static/media/Fondo 1.b4611dc4.png";